import { Fragment, useState } from "react"
import { Dialog, Transition } from "@headlessui/react"

const ReasonWindow = ({
  open,
  close = () => {},
  okCallback = () => {},
  title = "Reason",
  message = "Please provide a reason.",
  placeholder = "Enter a reason...",
  required = true,
}) => {
  const [reason, setReason] = useState("")
  const [error, setError] = useState(false)

  const onClickOk = () => {
    if (required && !reason.trim()) {
      setError(true)
      return
    }
    okCallback(reason.trim())
    setReason("")
    setError(false)
    close()
  }

  const onClickClose = () => {
    setReason("")
    setError(false)
    close()
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4 sm:mt-[6%] sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-md bg-white text-left transition-all sm:my-8 w-full sm:max-w-[30em] h-full">
                <div className="bg-white">
                  <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <h3 className="text-lg font-medium leading-tight tracking-tight text-gray-700 md:text-lg">
                      {title}
                    </h3>
                    <p className="text-sm text-gray-500">{message}</p>
                    <textarea
                      rows={4}
                      value={reason}
                      placeholder={placeholder}
                      onChange={(e) => {
                        setReason(e.target.value)
                        if (e.target.value.trim()) setError(false)
                      }}
                      className="block w-full rounded-md border border-gray-300 p-2.5 text-sm text-gray-700 focus:border-amber-400 focus:outline-none focus:ring-1 focus:ring-amber-400"
                    />
                    {error && <span className="text-red-600 text-xs">Reason is required</span>}
                  </div>
                </div>

                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    onClick={onClickOk}
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-amber-400 px-4 py-2 text-base font-medium text-white hover:opacity-80 focus:outline-none  sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Continue
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={onClickClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default ReasonWindow
